import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserToken } from "../../libs/user";
import { getLinkToken } from "../../services/auth";
import { startLoader, stopLoader } from "./appSlice";
import {
  cricbuzzResendOtpService,
  cricbuzzSendOtpService,
  cricbuzzVerifyOtpService,
} from "../../services/remittance";

const initialState = {
  bridgeData: null,
  nbStatusInfo: null,
  back: false,
  isBackBtnEnabled: false,
  isLogout: false,
  sendOtpData: {
    data: [],
    error: null,
    status: null,
  },
  verifyOtpData: {
    data: [],
    error: null,
    status: null,
  },
  resendOtpData: {
    data: [],
    error: null,
    status: null,
  },
};

export const fetchLinkToken = createAsyncThunk(
  "remittance/fetchLinkToken",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState();
      const { fingerprint, remittance } = state || {};
      if (remittance.bridgeData) {
        return;
      }
      const token = getUserToken();
      const response = await getLinkToken(token, fingerprint.data);
      if (response?.success) {
        return response;
      }
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const cricbuzzSendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { id, token, action_type, mobile_number } = obj;
      const response = await cricbuzzSendOtpService(
        id,
        token,
        action_type,
        mobile_number
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const cricbuzzVerifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { message_id, mobile_number, otp } = obj;
      const response = await cricbuzzVerifyOtpService(
        message_id,
        mobile_number,
        otp
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const cricbuzzResendOtp = createAsyncThunk(
  "auth/resendOtp",
  async (obj, { rejectWithValue, dispatch }) => {
    try {
      dispatch(startLoader());
      const { message_id, mobile_number } = obj;
      const response = await cricbuzzResendOtpService(
        message_id,
        mobile_number,
      );
      dispatch(stopLoader());
      return response;
    } catch (error) {
      dispatch(stopLoader());
      return rejectWithValue(error.response.data);
    }
  }
);

export const remittanceSlice = createSlice({
  name: "remittance",
  initialState: initialState,
  reducers: {
    updateBridgeData: (state, action) => {
      if (state.bridgeData) {
        state.bridgeData = {
          ...state.bridgeData,
          ...action.payload,
        };
        return;
      }
      state.bridgeData = {
        ...action.payload,
      };
    },
    deleteBridgeData: (state) => {
      state.bridgeData = null;
    },
    updateNbStatusInfo: (state, action) => {
      state.nbStatusInfo = { ...action.payload };
    },
    goBack: (state, action) => {
      state.back = action.payload;
    },
    toggleBackBtnVisiblity: (state, action) => {
      state.isBackBtnEnabled = action.payload;
    },
    setLogout: (state, action) => {
      state.isLogout = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLinkToken.fulfilled, (state, action) => {
        state.bridgeData = { ...action.payload, success: true };
      })
      .addCase(fetchLinkToken.rejected, (state, action) => {
        state.bridgeData = { ...action.payload, success: false };
      })

      .addCase(cricbuzzSendOtp.pending, (state, action) => {
        state.sendOtpData = { ...state.sendOtpData, status: "loading" };
      })
      .addCase(cricbuzzSendOtp.fulfilled, (state, action) => {
        state.sendOtpData = {
          ...state.sendOtpData,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(cricbuzzSendOtp.rejected, (state, action) => {
        state.sendOtpData = {
          ...state.sendOtpData,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })

      .addCase(cricbuzzVerifyOtp.pending, (state, action) => {
        state.verifyOtpData = { ...state.verifyOtpData, status: "loading" };
      })
      .addCase(cricbuzzVerifyOtp.fulfilled, (state, action) => {
        state.verifyOtpData = {
          ...state.verifyOtpData,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(cricbuzzVerifyOtp.rejected, (state, action) => {
        state.verifyOtpData = {
          ...state.verifyOtpData,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })
      .addCase(cricbuzzResendOtp.pending, (state, action) => {
        state.resendOtpData = { ...state.resendOtpData, status: "loading" };
      })
      .addCase(cricbuzzResendOtp.fulfilled, (state, action) => {
        state.resendOtpData = {
          ...state.resendOtpData,
          status: "succeeded",
          data: action.payload,
          error: null,
        };
      })
      .addCase(cricbuzzResendOtp.rejected, (state, action) => {
        state.resendOtpData = {
          ...state.resendOtpData,
          status: "failed",
          error: action.payload,
          data: [],
        };
      })

  },
});

export const {
  updateBridgeData,
  deleteBridgeData,
  updateNbStatusInfo,
  goBack,
  toggleBackBtnVisiblity,
  setLogout,
  reset,
} = remittanceSlice.actions;

export default remittanceSlice.reducer;
